// extracted by mini-css-extract-plugin
export var banner = "_f3-0";
export var closeButton = "_f3-2";
export var greenCheckmark = "_f3-3";
export var hereLink = "_f3-4";
export var titleIcon = "_f3-1";